angular
    .module('goodDescriptionAccordion.components', [])
    .component('goodDescriptionAccordion', {
        templateUrl: 'ng/components/goodDescriptionAccordion/goodDescriptionAccordion.view.html',
        bindings: {
            //object:'<'
            idProduct: '<',
            idUser: '<',
            transactionId: '<',
            onProductChosen: '&?',
            priceList: '<',
            instantModel: '<'
        },
        controllerAs: 'ordergoodDescriptionAccordionCtrl',
        controller: function orderCtrl($instantService, $transactionFactory, InstantModel) {

            var self = this;

            self.$onInit = function () {
                self.totale = 0;

                self.titolo = self.titolo || 'IL MIO ORDINE';
                if (typeof self.instantModel.rata.month != "undefined") {
                    self.onProductChosen({
                        instantModel: self.instantModel
                    });
                    return
                }
                self.isFinish = false;

                self.tempTransactionFactory = $transactionFactory.get();
                self.product = {};
                self.loading = true;
                /*
                $instantService.getProductDetail(self.tempTransactionFactory.appIlTransaction.identifierVendor,
                        self.tempTransactionFactory.appIlTransaction.idBene, self.tempTransactionFactory.appIlTransaction.id)
                    .then(function (response) {

                        self.product = Product.build(response.appProduct);
                        self.priceList = response;

                        //setto dettagli listino
                        response.appPriceList.pSecondo = 1;
                        response.appPriceList.cdConverzione = response.appPriceList.id;
                        response.appPriceList.amount = response.appProduct.value;
                        response.appIlTransaction = self.tempTransactionFactory.appIlTransaction;
                        if (response.appProduct.quantity != 0) {
                            response.appProduct.prezzoUnitario = response.appProduct.value / response.appProduct.quantity
                        }
                        self.instantModel = InstantModel.build(response)
                        self.onProductChosen({
                            instantModel: self.instantModel
                        });
                    })
                    .finally(function () {
                        self.loading = false;
                    });
*/

                $instantService.getChart(self.tempTransactionFactory.appIlTransaction.id)
                    .then(function (response) {

                        console.log(response);
                        self.product = response.listAppProduct;
                        self.priceList = response;
                        //setto dettagli listino
                        response.appPriceList.pSecondo = 1;
                        response.appPriceList.cdConverzione = response.appPriceList.id;
                        response.appPriceList.amount = response.amount;
                        response.appIlTransaction = self.tempTransactionFactory.appIlTransaction;
                        //if (response.appProduct.quantity != 0) {
                        //  response.appProduct.prezzoUnitario = response.appProduct.value / response.appProduct.quantity
                        //}
                        self.instantModel = InstantModel.build(response)
                        self.onProductChosen({
                            instantModel: self.instantModel
                        });
                        console.log(self.test);

                    })
                    .catch(function (err) {
                        console.log(err)
                    })


            }

        }
    });